export const customerTicketing = {
  customerTicketing: {
    mainLogoLabel: 'SAP',
    mainTitle: 'Billetterie client',
    ticketId: 'ID',
    createdOn: 'Créé le',
    changedOn: 'Modifié le',
    status: 'Statut',
    message: 'Message',
    cancel: 'Annuler',
    submit: 'Soumettre',
    uploadFile: 'Téléverser un fichier',
    fileSizeLimit: 'Limite de taille du fichier : {{count}} Mo',
    maximumAttachment: 'Maximum d\'une pièce jointe par message',
    errorMessage: 'Une erreur est survenue.',
    charactersLeft: 'caractères restants : {{count}}',
    customerService: 'Service à la clientèle',
  },
  customerTicketingList: {
    subject: 'Objet',
    ticketCategory: 'Catégorie',
    sortSubtitle: 'Trier par',
    sortOrders: 'Trier les commandes',
    noTickets: 'Vous n\'avez aucune demande',
    requestTitle: 'Toutes les demandes',
    mobile: {
      ticketIdFull: 'ID du billet',
    },
  },
  createCustomerTicket: {
    createNewTicket: 'Ajouter',
    addNewRequest: 'Ajouter une nouvelle demande',
    addRequest: 'Ajouter une demande',
    subject: 'Objet',
    category: 'Catégorie',
    associateTo: 'Associer à',
    ticketCreated: 'Demande créée.',
    optionallySelectAssociatedObject: 'Sélectionner une option',
    selectCategory: 'Sélectionner une catégorie',
  },
  customerTicketingDetails: {
    requestReopened: 'Demande rouverte.',
    requestClosed: 'Demande fermée, vous pouvez la rouvrir si nécessaire.',
    reopenRequest: 'Rouvrir la demande',
    closeRequest: 'Fermer la demande',
    ticketNotFound: 'Billet introuvable.',
  },
  serviceTicketsForm: {
    label: {
      subject: 'Objet',
      message: 'Message',
      selectAFile: 'Sélectionner un fichier',
      chooseFile: 'Choisir un fichier',
      noFileChosen: 'Aucun fichier choisi',
      category: 'Catégorie',
    },
    button: {
      submit: 'Soumettre',
    },
  },
};
